import React from 'react'

const Title = () => {
  return (
    <div className="title">
      <h1>CITRICS</h1>
      <h3>Compare cities. Find your new home.</h3>
    </div>
  )
}

export default Title
